"use client";

import Image from "next/image";
import React from "react";
import certified from "@/assest/certified.png";
import ui4 from "@/assest/ui4.png";
import { ArrowRight, CheckCircle } from "lucide-react";
// import CountUp from "@/utils/countDisplay";
import Title from "@/core/common/Title";
import {
  IAboutUsStats,
  IAboutUsWhoWeAre,
} from "@/app/about-us/interface/IAboutUs";
import Link from "next/link";

const whoweare = [
  "Best Travel Deals",
  "We Know Travel",
  "Flexible Bookings",
  "24/7 Assistance",
];

interface WhoWeAreProps {
  whoWeAreData?: IAboutUsWhoWeAre | null;
  stats?: IAboutUsStats | null;
}
const WhoWeAre = ({ whoWeAreData, stats }: WhoWeAreProps) => {
  const image1 = whoWeAreData?.images[0];
  const image2 = whoWeAreData?.images[1];
  const image3 = whoWeAreData?.images[2];
  return (
    <div className="relative">
      <div className="padding-x">
        <Title greenText="Who " yellowText="We Are" />
        <div className="flex flex-col md:flex-row gap-60 relative">
          <Image
            // src={image1}
            src={image1 || "/whoWeAre1.png"}
            alt="Good Travel Banner"
            width={500}
            height={420}
            className="rounded-3xl md:h-[55vh] h-[45vh] w-[80vw] md:w-[34vw] border-2 border-grey-100 shadow-[0_0_12px_0_#0000003D] object-cover"
          />
          <div className="rounded-3xl absolute top-24 left-60 md:top-20 w-full md:left-[35%] z-20">
            <Image
              src={certified}
              alt="Good Travel Banner"
              width={500}
              height={420}
              className="rounded-3xl h-28 w-28 md:h-[18vh] md:w-[8vw] object-cover"
            />
          </div>
          {image2 && (
            <div className="rounded-3xl absolute bottom-[60%] left-32 md:bottom-10 md:left-72">
              <Image
                src={image2 || "/src/assest/whoWeAre2.png"}
                alt="Good Travel Banner"
                width={500}
                height={420}
                className="rounded-3xl h-[30vh] w-[70vw] md:h-[25vh] md:w-[20.0vw] border-8 border-white shadow-[0_0_12px_0_#0000003D] object-cover"
              />
            </div>
          )}
          {image3 && (
            <div className="rounded-3xl absolute bottom-[50%] right-[20%] md:-bottom-10 md:left-32 z-20">
              <Image
                src={image3}
                alt="Good Travel Banner"
                width={500}
                height={420}
                className="rounded-2xl h-[22vh] w-[70vw] md:w-[20.8vw] border-8 border-white shadow-[0_0_12px_0_#0000003D] object-cover"
              />
            </div>
          )}
          <div>
            <div>
              <p
                className="typography-extra-large-body-light font-extralight text-grey-900 my-5"
                dangerouslySetInnerHTML={{
                  __html: whoWeAreData?.description || "",
                }}
              ></p>
            </div>
            <div className="flex flex-row gap-10 my-5">
              <div>
                <p className="typography-h4-regular">
                  {/* <CountUp target={stats?.total_packages} /> */}
                  {stats?.total_packages}
                </p>
                <p className="typography-extra-large-body-light">
                  Find the best fares & packages
                </p>
              </div>
              <div>
                <p className="typography-h4-regular">
                  {/* <CountUp target={stats?.year_experience} /> */}
                  {stats?.year_experience}
                </p>
                <p className="typography-extra-large-body-light">
                  With 38+ years of expertise
                </p>
              </div>
            </div>
            <div className="flex flex-col gap-3 my-4">
              {whoweare.map((item, index) => (
                <div
                  className="typography-sub-h3-light inline-flex gap-2 hover:scale-105 duration-700 items-center"
                  key={index}
                >
                  <CheckCircle />
                  {item}
                </div>
              ))}
            </div>
            <Link href="/package">
              <button className="typography-sub-h3-light text-white px-7 py-3 my-4 rounded-4xl bg-primary-500 hover:bg-primary-600 inline-flex gap-3 items-center">
                See Holidays Detail <ArrowRight />
              </button>
            </Link>
          </div>
        </div>
      </div>
      <Image
        src={ui4}
        alt="ui accent"
        width={500}
        height={500}
        className="absolute hidden lg:block w-screen top-0 left-0 z-0 object-cover scale-110 -rotate-3"
      />
    </div>
  );
};

export default WhoWeAre;
